<template>
	<div class="game-screen paw-bg">
		<MuteToggle class="mute-btn" eventCategory="Pre-Game" />
		<div class="content">
			<div class="sponsorship">
				<img class="sponsor-logo" src="@assets/img/ngpf-fulltext.svg" />
				<span class="sponsor-text">{{ ui.sponsor_text }}</span>
			</div>
			<img src="@assets/img/logo.svg" class="logo" />
			<div class="intro" v-html="ui.intro_text"></div>
			<Button :action="begin">{{ ui.button_text }}</Button>
		</div>
	</div>
</template>

<script>
import Button from '@/components/abstract/Button';
import MuteToggle from '@/components/abstract/MuteToggle';
import { mapState } from 'vuex';

export default {
	name: 'IntroScreen',
	components: {
		Button,
		MuteToggle,
	},
	computed: {
		...mapState({
			ui: state => state.config.ui.intro_screen,
		}),
	},
	methods: {
		begin() {
			this.$store.dispatch("loadView", { view: "CatSelector" });
		},
	},
};
</script>

<style lang="scss" scoped>
	.sponsorship {
		height: 1em;
		display: flex;
		align-items: center;
		justify-content: center;
		letter-spacing: .07em;
		text-transform: uppercase;
		font-weight: 700;
		font-size: 150%;
	}

	.sponsor-logo {
		display: inline-block;
		width: 120px;
		margin-right: .75ch;

		@include mobile {
			width: 80px;
		}
	}

	.sponsor-text {
		font-size: 20px;
	}

	.logo {
		display: block;
		width: 100%;
		margin: 1.5em auto 1em;
		max-width: 675px;
		max-height: 50vh;
	}

	.intro {
		margin-bottom: 2em;
		margin-top: 1em;
		font-size: 26px;
		font-weight: 400;
		letter-spacing: .03em;

		@include mobile {
			font-size: 20px;
		}
	}

	button {
		margin: 0 auto;
	}

	.mute-btn {
		position: absolute;
		top: 2vh;
		right: 2vw;
	}

	.tag-load {
		position: fixed;
		visibility: hidden;
	}
</style>



// WEBPACK FOOTER //
// src/components/views/IntroScreen.vue